<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import download from '@/utils/download'
    const directTypeList = {open:"持仓",close:"平仓",default:"自填推荐人"};
    export default {
        name: 'direct',
        components: {
            tablePage,
            FORM,
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t('txmis.bt.down') == clickName){
                    //隐藏关键字段
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
                    download.exportExcel(URL.share.direct.export,param,"推荐转化记录");
                }else if(window.$t('txmis.bt.export') == clickName){
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.share.direct.export,param,"推荐转化记录");
                }
            },
        },
        created(){
            this.formData.cols = [
                { title:"推荐账号" , field: 'directAccount',data:this.$route.query.accountNo},
                { title:"推荐手机号" , field: 'directPhone'},
                { title:"分享场景" , field: 'directType',data:this.$route.query.directType,type:2,optionList:directTypeList},
                { title: window.$t('txmis.common.startTime'), field: 'startTime',type:5},
                { title: window.$t('txmis.common.endTime'), field: 'endTime',type:5},
                {click:window.$t('txmis.bt.search')},
                {click: window.$t('txmis.bt.down'),auth:"tracker.down"},
                {click: window.$t('txmis.bt.export'),auth:"tracker.export"},
            ]
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.share.direct.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title:"推荐账号" , field: 'directAccount'},
                        { title:"推荐手机号" , field: 'directPhone'},
                        { title:"转化账号" , field: 'accountNo'},
                        { title:"转化手机号" , field: 'mobilePhone'},
                        { title:"分享场景" , field: 'directType',render:(data,full)=>{
                                return directTypeList[data];
                            }},
                        { title:"分享时间" , field: 'createTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                    ]
                }
            }
        }
    }
</script>
